import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Returning from Google OAuth: AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    if (!localStorage.getItem("cds_token")) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("cds_token"))
      .finally(() => setLoading(false));
  }, []);

  const setSession = useCallback((data) => {
    localStorage.setItem("cds_token", data.token);
    setUser(data.user);
  }, []);

  const clearSession = useCallback(() => {
    localStorage.removeItem("cds_token");
    localStorage.removeItem("cds_tenant");
    setUser(null);
  }, []);

  const login = async (email, password, remember_me = false) => {
    const { data } = await api.post("/auth/login", { email, password, remember_me });
    if (!data.mfa_required) setSession(data);
    return data;
  };

  const verifyMfa = async (mfa_token, code) => {
    const { data } = await api.post("/auth/mfa/verify", { mfa_token, code });
    setSession(data);
    return data.user;
  };

  const startDemo = async () => {
    const { data } = await api.post("/demo/session");
    localStorage.removeItem("cds_tenant");
    setSession(data);
    return data.user;
  };

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("logout: server session already gone", e?.message); }
    localStorage.removeItem("cds_token");
    localStorage.removeItem("cds_tenant");
    setUser(null);
    window.location.href = user?.demo ? "/" : user?.role === "customer" ? "/customer/login" : "/admin/login";
  };

  return <Ctx.Provider value={{ user, loading, login, verifyMfa, startDemo, loginWithGoogle, logout, setSession, clearSession }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
